import ShareCertificatePage from "./components/shareCertificatePage";
import React, { Suspense, lazy } from "react";
import { createBrowserRouter } from "react-router-dom";

import Registration from "./pages/Auth/registerForm";
import UserLogin from "./pages/Auth/userLogin";
import UserOtp from "./pages/Auth/otp";
import Landing from "./pages/landing/index.js";
import AgentLogin from "./pages/Auth/agentLogin";
import AgentOtp from "./pages/Auth/agentOtp";
import CreatePassword from "./pages/Auth/createPassword";

const Payment = lazy(() => import("./pages/Auth/payment"));
const ForgotPassword = lazy(() => import("./pages/Auth/forgotPassword"));
const EmailVerification = lazy(() => import("./pages/Auth/emailVerification"));
const ResetPassword = lazy(() => import("./pages/Auth/resetPassword"));
const ResetSuccessful = lazy(() => import("./pages/Auth/resetSuccessful"));
const Welcome = lazy(() => import("./pages/Auth/welcomeScreen"));

const SubscriptionPlan = lazy(() => import("./pages/Auth/subscriptionPlan"));
const Mainpage = lazy(() => import("./pages/Main/mainPage"));
const Dashboard = lazy(() => import("./pages/Main/dashboard.js"));
const CertificateHolders = lazy(() =>
  import("./pages/Main/certificateHolders")
);
const Profile = lazy(() => import("./pages/Main/profile"));
const SubscriptionDetails = lazy(() =>
  import("./pages/Main/subscriptionDetails/index.js")
);
const Settings = lazy(() => import("./pages/Main/settings/index.js"));
const UpgradePlan = lazy(() => import("./components/upgradePlan.js"));
const AddCard = lazy(() => import("./components/addCard.js"));
const CompaniesCertificates = lazy(() =>
  import("./components/companiesCertificates.js")
);
const Draft = lazy(() => import("./pages/Main/drafts/index.js"));
const UserLayout = lazy(() => import("./pages/User/UserLayout/index.js"));
const UserDashboard = lazy(() => import("./pages/User/userDashboard/index.js"));
const CertficatePDFPage = lazy(() => import("./pages/Certificate"));
const CertificateHeader = lazy(() =>
  import("./pages/Main/dashboard.js/certificateHeader")
);
const InsuredHeader = lazy(() =>
  import("./pages/Main/dashboard.js/insuredHeader")
);
const InsuredCertificate = lazy(() =>
  import("./pages/Main/dashboard.js/insuredCertificate")
);
const Automoboileliability = lazy(() =>
  import("./pages/Main/dashboard.js/automoboileliability")
);
const Insurance = lazy(() => import("./pages/Main/dashboard.js/insurance"));
const Certificate = lazy(() => import("./pages/Main/dashboard.js/certificate"));
const PhysicalDamage = lazy(() =>
  import("./pages/Main/dashboard.js/physicalDamage")
);
const CertificateFooter = lazy(() =>
  import("./pages/Main/dashboard.js/certificateFooter")
);
const PageNotFound = lazy(() => import("./components/404.js"));
const PrivacyPolicy = lazy(() => import("./pages/privacyPolicy"));
const TermsConditions = lazy(() => import("./pages/termsConditions"));
const PaymentVerify = lazy(() => import("./pages/Main/paymentVerify"));
const PaymentFailed = lazy(() => import("./pages/Main/paymentCancel"));
const AdminLayout = lazy(() => import("./pages/Admin/adminLayout/index.js"));
const AgentsList = lazy(() => import("./pages/Admin/agentsList/index.js"));
const AgentCompanyList = lazy(() =>
  import("./pages/Admin/agentCompanyList/index.js")
);
const AdminDashboard = lazy(() => import("./pages/Admin/adminDashboard"));
const Configuration = lazy(() => import("./pages/Admin/configuration"));
const AdminDrafts = lazy(() => import("./pages/Admin/adminDraft"));
const AdminagentDetails = lazy(() =>
  import("./components/adminAgentDetails.js")
);
const AdminCompanyDetails = lazy(() =>
  import("./components/adminCompanyDetails.js")
);
const AdminCertificate = lazy(() => import("./pages/Admin/adminCertificate"));
const SubscriptionSettings = lazy(() =>
  import("./pages/Admin/subscriptionSettings")
);
const BillingHistory = lazy(() => import("./pages/Admin/BillingHistory"));
const AdminLogin = lazy(() => import("./pages/Admin/auth/login"));
const CertificateContactInfo = lazy(() =>
  import("./pages/Main/dashboard.js/certificateContactInfo.js/index.js")
);
const UserProfile = lazy(() => import("./pages/User/profile"));
// const ShareCertificatePage = lazy(() =>
//   import("./components/shareCertificatePage")
// );

const router = createBrowserRouter([
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: "/agent/registration",
    element: <Registration />,
  },
  {
    path: "/user/login",
    element: <UserLogin />,
  },
  {
    path: "/user/verification",
    element: <UserOtp />,
  },
  {
    path: "/agent/login",
    element: <AgentLogin />,
  },
  {
    path: "/agent/otp",
    element: <AgentOtp />,
  },
  {
    path: "/agent/create-password",
    element: <CreatePassword />,
  },
  {
    path: "/agent/payment",
    element: (
      <Suspense fallback={<div></div>}>
        <Payment />
      </Suspense>
    ),
  },
  {
    path: "/agent/forgot-password",
    element: (
      <Suspense fallback={<div></div>}>
        <ForgotPassword />
      </Suspense>
    ),
  },
  {
    path: "/agent/email-link",
    element: (
      <Suspense fallback={<div></div>}>
        <EmailVerification />
      </Suspense>
    ),
  },
  {
    path: "/agent/reset-password",
    element: (
      <Suspense fallback={<div></div>}>
        <ResetPassword />
      </Suspense>
    ),
  },
  {
    path: "payment-verify",
    element: (
      <Suspense>
        <PaymentVerify />
      </Suspense>
    ),
  },
  {
    path: "payment-failed",
    element: (
      <Suspense>
        <PaymentFailed />
      </Suspense>
    ),
  },
  {
    path: "/agent/reset-successful",
    element: (
      <Suspense fallback={<div></div>}>
        <ResetSuccessful />
      </Suspense>
    ),
  },
  {
    path: "/welcome",
    element: (
      <Suspense fallback={<div></div>}>
        <Welcome />
      </Suspense>
    ),
  },
  {
    path: "certificate-pdf/:id",
    element: (
      <Suspense fallback={<div></div>}>
        <CertficatePDFPage />
      </Suspense>
    ),
  },
  {
    path: "/agent/subscription-plan",
    element: (
      <Suspense fallback={<div></div>}>
        <SubscriptionPlan />
      </Suspense>
    ),
  },
  {
    path: "main/user/*",
    element: (
      <Suspense fallback={<div></div>}>
        <UserLayout />
      </Suspense>
    ),
    children: [
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<div></div>}>
            <UserDashboard />
          </Suspense>
        ),
      },
      {
        path: "profile",
        element: (
          <Suspense fallback={<div></div>}>
            <UserProfile />
          </Suspense>
        ),
      },
      {
        path: "*",
        element: (
          <Suspense fallback={<div></div>}>
            <PageNotFound />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "main/*",
    element: (
      <Suspense fallback={<div></div>}>
        <Mainpage />
      </Suspense>
    ),
    children: [
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<div></div>}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: "certificate-details/:companyId",
        element: (
          <Suspense fallback={<div></div>}>
            <CompaniesCertificates />
          </Suspense>
        ),
      },
      // {
      //   path: "certificate-header",
      //   element: (
      //     <Suspense fallback={<div></div>}>
      //       <CertificateHeader />
      //     </Suspense>
      //   ),
      // },
      // {
      //   path: "certificate-header/:certificateId",
      //   element: (
      //     <Suspense fallback={<div></div>}>
      //       <CertificateHeader />
      //     </Suspense>
      //   ),
      // },
      {
        path: "certificate-contact-info",
        element: (
          <Suspense fallback={<div></div>}>
            <CertificateContactInfo />
          </Suspense>
        ),
      },
      {
        path: "certificate-contact-info/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <CertificateContactInfo />
          </Suspense>
        ),
      },
      {
        path: "insured-header/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <InsuredHeader />
          </Suspense>
        ),
      },
      {
        path: "insured-certificate/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <InsuredCertificate />
          </Suspense>
        ),
      },
      {
        path: "automoboileliability/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <Automoboileliability />
          </Suspense>
        ),
      },
      {
        path: "insurance/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <Insurance />
          </Suspense>
        ),
      },
      {
        path: "certificate/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <Certificate />
          </Suspense>
        ),
      },
      {
        path: "physical-damage/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <PhysicalDamage />
          </Suspense>
        ),
      },
      {
        path: "certificate-footer/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <CertificateFooter />
          </Suspense>
        ),
      },
      {
        path: "certificate-holders",
        element: (
          <Suspense fallback={<div></div>}>
            <CertificateHolders />
          </Suspense>
        ),
      },
      {
        path: "drafts",
        element: (
          <Suspense fallback={<div></div>}>
            <Draft />
          </Suspense>
        ),
      },
      {
        path: "profile",
        element: (
          <Suspense fallback={<div></div>}>
            <Profile />
          </Suspense>
        ),
      },
      {
        path: "subscription-details",
        element: (
          <Suspense fallback={<div></div>}>
            <SubscriptionDetails />
          </Suspense>
        ),
      },
      {
        path: "upgrade-plan",
        element: (
          <Suspense fallback={<div></div>}>
            <UpgradePlan />
          </Suspense>
        ),
      },
      {
        path: "add-card",
        element: (
          <Suspense fallback={<div></div>}>
            <AddCard />
          </Suspense>
        ),
      },
      {
        path: "settings",
        element: (
          <Suspense fallback={<div></div>}>
            <Settings />
          </Suspense>
        ),
      },
      {
        path: "*",
        element: (
          <Suspense fallback={<div></div>}>
            <PageNotFound />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/agent/privacy-policy",
    element: (
      <Suspense fallback={<div></div>}>
        <PrivacyPolicy />
      </Suspense>
    ),
  },
  {
    path: "/agent/terms-and-conditions",
    element: (
      <Suspense fallback={<div></div>}>
        <TermsConditions />
      </Suspense>
    ),
  },
  {
    path: "admin/login",
    element: (
      <Suspense fallback={<div></div>}>
        <AdminLogin />
      </Suspense>
    ),
  },
  {
    path: "/admin/otp",
    element: <AgentOtp />,
  },
  {
    path: "admin/*",
    element: (
      <Suspense fallback={<div></div>}>
        <AdminLayout />
      </Suspense>
    ),
    children: [
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<div></div>}>
            <AdminDashboard />
          </Suspense>
        ),
      },
      {
        path: "agents-list",
        element: (
          <Suspense fallback={<div></div>}>
            <AgentsList />
          </Suspense>
        ),
      },
      {
        path: "configuration",
        element: (
          <Suspense fallback={<div></div>}>
            <Configuration />
          </Suspense>
        ),
      },
      {
        path: "subscription-settings",
        element: (
          <Suspense fallback={<div></div>}>
            <SubscriptionSettings />
          </Suspense>
        ),
      },
      {
        path: "agent-details/:agentId",
        element: (
          <Suspense fallback={<div></div>}>
            <AdminagentDetails />
          </Suspense>
        ),
      },
      {
        path: "certificate-details/:companyId",
        element: (
          <Suspense fallback={<div></div>}>
            <CompaniesCertificates />
          </Suspense>
        ),
      },
      {
        path: "certificate-contact-info",
        element: (
          <Suspense fallback={<div></div>}>
            <CertificateContactInfo />
          </Suspense>
        ),
      },
      {
        path: "certificate-contact-info/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <CertificateContactInfo />
          </Suspense>
        ),
      },
      {
        path: "insured-header/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <InsuredHeader />
          </Suspense>
        ),
      },
      {
        path: "insured-certificate/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <InsuredCertificate />
          </Suspense>
        ),
      },
      {
        path: "automoboileliability/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <Automoboileliability />
          </Suspense>
        ),
      },
      {
        path: "insurance/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <Insurance />
          </Suspense>
        ),
      },
      {
        path: "certificate/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <Certificate />
          </Suspense>
        ),
      },
      {
        path: "physical-damage/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <PhysicalDamage />
          </Suspense>
        ),
      },
      {
        path: "certificate-footer/:certificateId",
        element: (
          <Suspense fallback={<div></div>}>
            <CertificateFooter />
          </Suspense>
        ),
      },
      // {
      //   path: "company-list",
      //   element: (
      //     <Suspense fallback={<div></div>}>
      //       <AgentCompanyList />
      //     </Suspense>
      //   ),
      // },
      // {
      //   path: "drafts",
      //   element: (
      //     <Suspense fallback={<div></div>}>
      //       <AdminDrafts />
      //     </Suspense>
      //   ),
      // },
      // {
      //   path: "company-details",
      //   element: (
      //     <Suspense fallback={<div></div>}>
      //       <AdminCompanyDetails />
      //     </Suspense>
      //   ),
      // },
      // {
      //   path: "certificate-details",
      //   element: (
      //     <Suspense fallback={<div></div>}>
      //       <AdminCertificate />
      //     </Suspense>
      //   ),
      // },
      // {
      //   path: "billing-history",
      //   element: (
      //     <Suspense fallback={<div></div>}>
      //       <BillingHistory />
      //     </Suspense>
      //   ),
      // },
      {
        path: "*",
        element: (
          <Suspense fallback={<div></div>}>
            <PageNotFound />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/share/:shareId/certificate.pdf",
    element: <ShareCertificatePage />,
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<div></div>}>
        <PageNotFound />
      </Suspense>
    ),
  },
]);

export default router;
